<script lang="ts">
  import CtaUrlButton from "../../../../components/Header/CtaUrlButton.svelte"
  import Title2 from "../../components/Title2.svelte"
  import Text from "../../components/Text.svelte"
</script>

<section>
  <Title2 class="cta-title">Get Started Today</Title2>
  <Text class="cta-text"
    >Schedule a free consultation to see if dental implants are right for you.</Text
  >
  <CtaUrlButton />
</section>

<style lang="scss">
  section {
    background-color: #0a2f54;
    text-align: center;
    padding: 47px 20px;
  }

  :global(.cta-title) {
    color: white !important;
    margin-bottom: 12px !important;
  }

  :global(.cta-text) {
    color: white !important;
    margin-bottom: 24px !important;
  }

	@media (min-width: 768px) {
  section {
    padding: 54px 0;
  }
	}
</style>
